<template>
    <div
        v-if="qrCode.homepage.main_image_file"
        class="mx-auto relative mb-4 md:mb-0 mt-0 md:mt-16"
        :class="isPortrait ? 'max-w-md' : ''"
    >
        <div class="absolute right-4 top-4 flex gap-2">
            <QrButton
                @click="modalOpen = true"
                :text="trans('button.change-image')" trans="button.change-image"
                icon-right="image-landscape"
                secondary
                small
            />
            <QrButton
                danger
                small
                :text="trans('button.delete-current-image')"
                trans="button.delete-current-image"
                :recently-succeeded="recentlySucceeded"
                :loading="loading"
                @click="qrCodeHomepageStore.deleteMainImage"
            />
        </div>

        <img
            :src="qrCode.homepage.main_image_file.file"
            alt=""
            class="rounded-lg"
            @load="setImageOrientation"
        />
    </div>
    <div v-else class="w-full h-full mt-6 md:mt-16 ml-0 md:ml-4">
        <div class="mx-auto max-w-[649px] max-h-[287px] sm:max-h-[387px] md:max-h-[487px] w-full h-full bg-slate-200 rounded-lg flex">
            <div class="m-auto flex flex-col py-16">
                <QrIcon icon="image-landscape" class="text-slate-400 w-32 h-32 m-auto"/>
                <QrButton
                    @click="modalOpen = true"
                    :text="trans('button.add-main-image')" trans="button.add-main-image"
                    icon-right="image-landscape"
                />
            </div>
        </div>
    </div>

    <QrModal v-model="modalOpen" large :title="trans('homepage.main-image')" :close-text="trans('button.close')">
        <QrImageCropAndUpload
            v-if="modalOpen"
            ref="imageUploader"
            :helper-text="trans('form.image-types-and-size')"
            :endpoint="`/api/qr-codes/${qrCode.id}/homepage/main-image`"
            @upload-complete="uploadComplete"
        />

        <template #buttons>
            <QrButton
                positive
                icon-right="arrow-up-to-arc"
                :disabled="!canUseImage"
                :loading="imageUploading"
                :text="trans('button.use-image')"
                trans="button.use-image"
                @click="useImage"
            />
        </template>
    </QrModal>
</template>

<script setup>
import { trans } from "@/libs/helper.js";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import QrModal from "@/components/application-ui/dialogs/QrModal.vue";
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useQrCodesStore } from "@/store/qrCodes.js";
import QrImageCropAndUpload from "@/components/application-ui/form/QrImageCropAndUpload.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import { useQrCodeHomepageStore } from "@/store/qrCodeHomepage.js";
import { useStatesStore } from "@/store/states.js";

const qrCodeStore = useQrCodesStore();
const { qrCode } = storeToRefs(qrCodeStore);

const statesStore = useStatesStore();
const { loading, recentlySucceeded } = storeToRefs(statesStore);

const qrCodeHomepageStore = useQrCodeHomepageStore();
const modalOpen = ref(false);
const isPortrait = ref(false);
const imageUploader = ref(null);
const canUseImage = computed(() => imageUploader.value?.canUpload ?? false);
const imageUploading = computed(() => imageUploader.value?.uploading ?? false);

const useImage = () => {
    imageUploader.value?.upload();
};

const setImageOrientation = (event) => {
    isPortrait.value = event.target.naturalHeight > event.target.naturalWidth;
};

const uploadComplete = ({ status, data }) => {
    if (status === 200) {
        qrCode.value = data.data;
        modalOpen.value = false;
    }
};

</script>
